import { it } from 'date-fns/locale/it';
import { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useAppDispatch, useAppSelector } from '../../../lib/redux/hooks';
import Button from "../../../ui/molecules/button";
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static";
import { formatterDate, Province, Region, regioniProvinceMap, regions } from "../../../utils";
import { provinceComuniMap } from "../../../utils/listaComuni";
import { GetBusinessTechnicianDTO } from "../../businessTechnician/dto";
import { GetBusinessTechnician, GetBusinessTechnicianById, setBusinessTechnician, setBusinessTechnicianByIdStatusIdle, setIdBusinessTechUser } from "../../businessTechnician/slice";
import { RemoveBusinessTechnician, resetGetUserByIdStatusIdle } from "../../users/slice";
import '../style.scss';

registerLocale('it', it)

type OptionType = {
    value: string;
    label: string;
};

export function BoxTecnicoAziendaleEdit() {

    const [showBoxBT, setShowBoxBT] = useState<boolean>(false);
    const sessionState = useAppSelector(state => state.session)
    const businessTechinianState = useAppSelector(state => state.businessTechinician)
    const userState = useAppSelector(state => state.users)
    const clientiState = useAppSelector(state => state.clienti)
    const [provinceOptions, setProvinceOptions] = useState<OptionType[]>([]);
    const [selectedRegion, setSelectedRegion] = useState<OptionType | null>(null);
    const [comuneOptions, setComuneOptions] = useState<OptionType[]>([]);
    const [selectedProvince, setSelectedProvince] = useState<OptionType | null>(null);
    const [selectedComune, setSelectedComune] = useState<OptionType | null>(null);
    const [optionsBT, setOptionsBT] = useState<OptionType[]>([]);
    const dispatch = useAppDispatch()
    const customerUserId = sessionState.selected.customerUserId || clientiState.getCustomersByIdResponse?.userId
    const regionOptions: OptionType[] = Array.from(regioniProvinceMap.keys()).map(region => ({
        value: region,
        label: region
    }));

    useEffect(() => {
        dispatch(setIdBusinessTechUser(undefined))
        dispatch(GetBusinessTechnician())
        if (businessTechinianState.idBusinessTechUser && businessTechinianState.idBusinessTechUser.length > 0) {
            dispatch(GetBusinessTechnicianById(businessTechinianState.idBusinessTechUser[businessTechinianState.idBusinessTechUser.length - 1]))
            dispatch(setBusinessTechnician(businessTechinianState.idBusinessTechUser[businessTechinianState.idBusinessTechUser.length - 1]))
        }

    }, [])

    useEffect(() => {
        if (userState.findUserByIdStatus === 'successfully') {
            dispatch(setIdBusinessTechUser(undefined))
            if (userState.findUserByIdResponse !== undefined) {

                if (userState.findUserByIdResponse.businessTechnicianIds !== undefined && userState.findUserByIdResponse.businessTechnicianIds.length > 0) {
                    dispatch(setIdBusinessTechUser(userState.findUserByIdResponse.businessTechnicianIds[userState.findUserByIdResponse.businessTechnicianIds.length - 1]))
                }

            }
            dispatch(resetGetUserByIdStatusIdle())
        }
    }, [userState.findUserByIdStatus])

    useEffect(() => {
        if (clientiState.customerEditStatus === 'successfully') {
            dispatch(GetBusinessTechnicianById(businessTechinianState.userBusinessTechnicianLink.techId))
        }
    }, [clientiState.customerEditStatus])

    useEffect(() => {
        if (businessTechinianState.userBusinessTechnicianLink.techId) {
            dispatch(GetBusinessTechnicianById(businessTechinianState.userBusinessTechnicianLink.techId))
        }
    }, [businessTechinianState.userBusinessTechnicianLink.techId])

    useEffect(() => {
        if (businessTechinianState.businessTechByIdStatus === 'successfully') {
            setShowBoxBT(true)
            dispatch(setBusinessTechnicianByIdStatusIdle())
        }
    }, [businessTechinianState.businessTechByIdStatus])

    useEffect(() => {
        if (businessTechinianState.businessTechinicianResponseStatus === 'successfully') {
            if (businessTechinianState.businessTechinicianResponse !== undefined) {
                const mappedOptions = businessTechinianState.businessTechinicianResponse.data.map((techinician: GetBusinessTechnicianDTO) => ({
                    value: techinician.id,
                    label: techinician.companyName
                }));
                setOptionsBT(mappedOptions);
            }

        }
    }, [businessTechinianState.businessTechinicianResponseStatus])


    useEffect(() => {
        if (selectedRegion) {
            const foundRegion = regions.find((region: Region) => region.name === selectedRegion.toString());
            if (foundRegion) {
                const newProvinceOptions = foundRegion.provinces.map((province: Province) => ({
                    value: province.code,
                    label: province.name
                }));
                setProvinceOptions(newProvinceOptions);
            } else {
                setProvinceOptions([]);
            }
        } else {
            setProvinceOptions([]);
        }
    }, [selectedRegion]);

    useEffect(() => {
        if (selectedProvince) {
            const comuni = provinceComuniMap.get(selectedProvince.toString()) || [];
            const newComuneOptions = comuni.map((comune: string) => ({
                value: comune,
                label: comune
            }));
            setComuneOptions(newComuneOptions);
        } else {
            setComuneOptions([]);
        }
    }, [selectedProvince]);

    const handleRegionChange = (selectedOption: OptionType | null) => {
        setSelectedRegion(selectedOption);
        setSelectedProvince(null); // Reset province when region changes
        setSelectedComune(null);
    };

    const handleProvinceChange = (selectedOption: OptionType | null) => {
        setSelectedProvince(selectedOption);
        setSelectedComune(null);
    };

    const handleComuneChange = (selectedOption: OptionType | null) => {
        setSelectedComune(selectedOption);
    };

    return (
        <>
            <div id="boxTecnicoAziendale" className="p-6">

                <>
                    <div className="rounded-xl border border-neutral-200 bg-white shadow-sm p-5">
                        <MadfarmStaticSelect
                            label="Tecnico Aziendale"
                            noOptionsMessage={'Nessun tecnico aziendale disponibile'}
                            defaultValue={businessTechinianState.userBusinessTechnicianLink.techId}
                            value={businessTechinianState.userBusinessTechnicianLink.techId}
                            placeholder={'Seleziona Tecnico'}
                            options={optionsBT}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : undefined;
                                dispatch(setBusinessTechnician(newValue))

                            }}
                        />
                    </div>
                    {(businessTechinianState.businessTechById !== undefined && businessTechinianState.businessTechById.id) && (
                        <div className="mt-6 overflow-hidden rounded-xl border border-neutral-200 bg-white shadow-sm">
                            <div className="flex items-center justify-between gap-4 border-b border-neutral-200 bg-brandPrimary-50 px-6 py-4">
                                <div className="min-w-0">
                                    <span className="block truncate text-lg font-semibold text-brandPrimary-800">{businessTechinianState.businessTechById.companyName}</span>
                                </div>

                                <div className="shrink-0">
                                    <Button size={"sm"} iconPosition={"off"} variant={"solid"} label="Dissocia" color={"red"}
                                        onClick={() => {
                                            if (businessTechinianState.businessTechById && businessTechinianState.businessTechById.id !== undefined && customerUserId !== undefined) {
                                                dispatch(RemoveBusinessTechnician({ id: customerUserId, techId: businessTechinianState.businessTechById.id }))
                                            }

                                        }}
                                    />
                                </div>
                            </div>
                            <div className="bg-white p-6">
                                <table className="w-full border-collapse text-sm">
                                    <tbody>
                                        <tr className="border-b border-neutral-200">
                                            <td className="w-[240px] py-3 pr-6 text-left font-semibold text-brandPrimary-700">Cognome e nome</td>
                                            <td className="py-3 text-left text-neutral-700">{businessTechinianState.businessTechById.companyName}</td>
                                        </tr>
                                        <tr className="border-b border-neutral-200 bg-neutral-50">
                                            <td className="w-[240px] py-3 pr-6 text-left font-semibold text-brandPrimary-700">Codice Fiscale</td>
                                            <td className="py-3 text-left text-neutral-700">{businessTechinianState.businessTechById.fiscalCode}</td>
                                        </tr>
                                        <tr className="border-b border-neutral-200">
                                            <td className="w-[240px] py-3 pr-6 text-left font-semibold text-brandPrimary-700">Partita IVA</td>
                                            <td className="py-3 text-left text-neutral-700">{businessTechinianState.businessTechById.vat}</td>
                                        </tr>
                                        <tr className="border-b border-neutral-200 bg-neutral-50">
                                            <td className="w-[240px] py-3 pr-6 text-left font-semibold text-brandPrimary-700">Regione</td>
                                            <td className="py-3 text-left text-neutral-700">{businessTechinianState.businessTechById.countryRegion}</td>
                                        </tr>
                                        <tr className="border-b border-neutral-200">
                                            <td className="w-[240px] py-3 pr-6 text-left font-semibold text-brandPrimary-700">Provincia</td>
                                            <td className="py-3 text-left text-neutral-700">{businessTechinianState.businessTechById.province}</td>
                                        </tr>
                                        <tr className="border-b border-neutral-200 bg-neutral-50">
                                            <td className="w-[240px] py-3 pr-6 text-left font-semibold text-brandPrimary-700">Comune</td>
                                            <td className="py-3 text-left text-neutral-700">{businessTechinianState.businessTechById.city}</td>
                                        </tr>
                                        <tr className="border-b border-neutral-200">
                                            <td className="w-[240px] py-3 pr-6 text-left font-semibold text-brandPrimary-700">Indirizzo</td>
                                            <td className="py-3 text-left text-neutral-700">{businessTechinianState.businessTechById.address}</td>
                                        </tr>
                                        <tr className="border-b border-neutral-200 bg-neutral-50">
                                            <td className="w-[240px] py-3 pr-6 text-left font-semibold text-brandPrimary-700">CAP</td>
                                            <td className="py-3 text-left text-neutral-700">{businessTechinianState.businessTechById.zipCode}</td>
                                        </tr>
                                        <tr className="border-b border-neutral-200">
                                            <td className="w-[240px] py-3 pr-6 text-left font-semibold text-brandPrimary-700">Email</td>
                                            <td className="py-3 text-left text-neutral-700">{businessTechinianState.businessTechById.email}</td>
                                        </tr>
                                        <tr className="border-b border-neutral-200 bg-neutral-50">
                                            <td className="w-[240px] py-3 pr-6 text-left font-semibold text-brandPrimary-700">PEC</td>
                                            <td className="py-3 text-left text-neutral-700">{businessTechinianState.businessTechById.pec}</td>
                                        </tr>
                                        <tr className="border-b border-neutral-200">
                                            <td className="w-[240px] py-3 pr-6 text-left font-semibold text-brandPrimary-700">Data Ingresso</td>
                                            <td className="py-3 text-left text-neutral-700">{formatterDate(businessTechinianState.businessTechById.activationDate)}</td>
                                        </tr>
                                        <tr className="border-b border-neutral-200 bg-neutral-50">
                                            <td className="w-[240px] py-3 pr-6 text-left font-semibold text-brandPrimary-700">Data Uscita</td>
                                            <td className="py-3 text-left text-neutral-700">{formatterDate(businessTechinianState.businessTechById.deactivationDate)}</td>
                                        </tr>
                                        <tr>
                                            <td className="w-[240px] py-3 pr-6 text-left font-semibold text-brandPrimary-700">Note</td>
                                            <td className="py-3 text-left text-neutral-700">{businessTechinianState.businessTechById.notes}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    )}
                </>

            </div>
        </>
    )
}